"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENERIC_LOGIN_ERROR_MESSAGE = exports.USER_NOT_FOUND_MESSAGE = void 0;
exports.USER_NOT_FOUND_MESSAGE = 'The combination of email address and password you entered is invalid.';
exports.GENERIC_LOGIN_ERROR_MESSAGE = 'We are working on it. Please try again later.';
